import { useState } from "react";

export const useHoveredState = (): {
    isHovered: boolean;
    handleMouseEnter: () => void;
    handleMouseLeave: () => void;
} => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };
    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return {
        isHovered,
        handleMouseEnter,
        handleMouseLeave,
    };
};
